import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';
import { ProjectRegisterVisualizationComponent } from './project-register-visualization.component';


@NgModule({
  declarations: [
    ProjectRegisterVisualizationComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ComponentsModule,
    B3DesignSystemWebModule,
  ],
  exports: [
    ProjectRegisterVisualizationComponent
  ],
  providers: [
    DatePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectRegisterVisualizationModule { }
